import { createSelector } from "@reduxjs/toolkit";

const rootChatSelecter = (state: TReduxState) => state.root.entities.chat;
const threadsSelector = (state: TReduxState) =>
  state.root.entities.chat.threads;

const threadsCountSelecter = (state: TReduxState) =>
  state.root.entities.chat.data;

export const selectThreads = createSelector(
  threadsSelector,
  (threads) => threads
);

export const selectThreadsCount = createSelector(
  threadsCountSelecter,
  (threads) => threads
);

export const selectActiveThread = createSelector(
  rootChatSelecter,
  (data) => data.activeThread
);

export const selectActiveThreadId = createSelector(
  rootChatSelecter,
  (data) => data.threadId
);

export const getChatPage = createSelector(
  rootChatSelecter,
  (data) => data.data.page
);

export const getChatPageCount = createSelector(
  rootChatSelecter,
  (data) => data.data.pageSize
);

export const getChatMaxSize = createSelector(
  rootChatSelecter,
  (data) => data.data.maxSize
);

export const getFilePopOver = createSelector(
  rootChatSelecter,
  (data) => data.selectFilePopup
);
export const getChatMode = createSelector(
  rootChatSelecter,
  (data) => data.mode 
);
export const getFileIndex = createSelector(
  rootChatSelecter,
  (data) => data.fileIndex
);
export const getFileIndexType = createSelector(
  rootChatSelecter,
  (data) => data.popOverIndexType
);
export const getSelectedFiles = createSelector(
  rootChatSelecter,
  (data) => data.selectedFiles
);
export const selectProfile = createSelector(
  rootChatSelecter,
  (data) => data.profile
);
